/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * ICittaAccordionCustom containerModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import * as React from 'react';

export const enum toggleAllFormat {
    text = 'text',
    glyph = 'glyph'
}

export interface ICittaAccordionCustomConfig extends Msdyn365.IModuleConfig {
    renderWithContainer?: boolean;
    renderAsDesignTeam?: boolean;
    hideDesignTeamTitles?: boolean;
    showBackToTopButton?: boolean;
    designTeamDetails?: IDesignTeamDetailsData[];
    accordionTitle?: string;
    showToggleAll?: boolean;
    toggleAllFormat?: toggleAllFormat;
    expandSingleItemOnly?: boolean;
}

export interface ICittaAccordionCustomResources {
    collapseAllText: string;
    expandAllText: string;
    toggleAllSeparator: string;
}

export interface IDesignTeamDetailsData {
    name: string;
    jobTitle: string;
    quote: string;
    image?: Msdyn365.IImageData;
}

export interface ICittaAccordionCustomProps<T> extends Msdyn365.IModule<T> {
    resources: ICittaAccordionCustomResources;
    config: ICittaAccordionCustomConfig;
    slots: {
        accordionItem: React.ReactNode[];
    };
}
